import React from 'react'
import verified from './static/verified.svg';
import remove from './static/remove.svg';
import pin from './static/pin.svg';
import notification from './static/notification.svg';
import favorite from './static/favorite.svg';
import add from './static/add.svg';

const topStatusIcons = {
    verified,
    remove,
    pin,
    notification,
    favorite,
    add,
};

function TopStatus({ topStatus, size }) {
    const iconSrc = topStatusIcons[topStatus];
    return (
        <div className={`pgn__avatar-top-status-${size}`}>
            <img className={`pgn__avatar-top-status-icon-${size}`} src={iconSrc} alt="" />
        </div>
    )
}

export default TopStatus